import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { getLocationsList } from '../../actions/locationActions.js';

class Ella extends React.Component {
    constructor(props) {
        super(props);
        this.goToClinicList = this.goToClinicList.bind(this);
    }

    goToClinicList() {
        this.props.history.push('/clinics');
    }
    
    render() {
        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <h1 className="ec__font__title text-center">Ella</h1>
                        <p className="ec__font__body text-center">
                        Ella is a type of EC that's good up to 5 days (120 hours) after unprotected sex;
                        it's also more effective for women over 165lbs.
                        </p>
                        <br/>
                        <br/>
                        <p className="ec__font__body--blue text-center">
                            You need a prescription to get ella. You can get this prescription from a doctor or clinic.
                            You can <a class="ec__body-link" target="_blank" rel="noopener"
                            href="https://www.prjktruby.com/about/products/ella/">
                                order ella online
                            </a>
                             - just make sure you'll be within the 120 hour limit when it arrives! 
                        </p>
                        <br/>
                        <p className="ec__font__body text-center">
                            Don’t have a regular doctor? <br/> Try a low-cost drop-in clinic below.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="choices col text-center">
                        <button className="ec__button" onClick={this.goToClinicList}>See Clinic List</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Ella;


// WEBPACK FOOTER //
// ./src/components/screens/Ella.js